export const PRODUCTTYPESCHOICES = [
  {value: 0, name: 'Tickets'},
  {value: 5, name: 'Mobile tickets'},
  {value: 1, name: 'Guest list spots'},
  {value: 2, name: 'Promotion codes'},
  {value: 3, name: 'Merchandise'},
];

export const PRODUCTSUBTYPESCHOICES = [
  {value: 'regular_product', name: 'Regular product'},
  {value: 'kpn', name: 'KPN'},
  {value: 'discounted_product', name: 'Personalised pricing (discount percentage)'},
  {
    value: 'fully_discounted_product',
    name: 'Personalised pricing (100% discount)',
  },
  {value: 'wingame_product', name: 'Wingame'},
];

export const VATTARIFFOPTIONS = [
  {value: 'vat_none', name: 'No VAT'},
  {value: 'vat_low', name: 'Low VAT'},
  {value: 'vat_high', name: 'High VAT'},
];

export const FIELDSDICTIONARY = [
  {value: 'available_from', name: 'Available from'},
  {value: 'relation_type', name: 'Relation type'},
  {value: 'expire_at', name: 'Expire at'},
  {value: 'ticket_handler', name: 'Ticket Handler'},
  {value: 'relation', name: 'Event'},
  {value: 'payment_service_provider', name: 'Payment service provider'},
  {value: 'service_fee_policy', name: 'Service Fee Policy'},
  {value: 'product_type', name: 'Product type'},
  {value: 'product_subtype', name: 'Product sub-type'},
  {value: 'title', name: 'Title'},
  {value: 'meta_tags', name: 'Search tags'},
  {value: 'product_pricing', name: 'Product pricing'},
  {value: 'invoicing_product_type', name: 'Invoicing Product Type'},
  {value: 'product_vat_country', name: 'Product VAT Country'},
  {value: 'product_vat_tariff_name', name: 'Product VAT tariff'},
  {value: 'service_fee_vat_country', name: 'Service fee VAT Country'},
  {value: 'service_fee_vat_tariff_name', name: 'Service fee VAT tariff'},
  {value: 'maximum_quantity_per_order', name: 'Maximum quantiti of products must be greater then 0'},
  {value: 'ticket_description', name: 'Ticket description'},
];

export const TICKETHANDLEROPTIONS = [
  {value: 'appic', name: 'Appic'},
  {value: 'eventix', name: 'Eventix'},
];

export const SERVICEFEEPOLICYOPTIONS = [
  {value: 'shop_precedence', name: 'Shop Precedence'},
  {value: 'product_precedence', name: 'Product Precedence'},
];
